import styled from 'styled-components'

export const FieldWrapper = styled.div`
  margin-bottom: 60px;
`
